import React from "react";
import Filled_Star from "../assets/Filled Star.png";
import Unfilled_Star from "../assets/Unfilled Star.png";
import "../styles/Star.css";

const StarSet = ({ rating }) => {
  // Ensure the rating is between 0 and 5
  const validRating = Math.max(0, Math.min(5, rating));

  return (
   
   <div className="star-set">
      {/* Render 5 stars */}
      <div className="stars-set">
        {[...Array(5)].map((_, index) => (
          <img
            key={index}
            src={index < validRating ? Filled_Star : Unfilled_Star}
            alt={`star-${index}`}
            className="starset"
          />
        ))}
      </div>
      {/* Render the rating number */}
      <div className="rating-number">({validRating}.0)</div>
    </div>
  );
};

export default StarSet;
